'use strict';

import cfsShortlist from '../../profile/cfs-shortlist';

const classNames = {
	siteHeaderMobile: 'site-header-mobile',
	cfsShortlistBadge: 'cfs-shortlist-badge',
	icon: 'icon',
	offCanvasSiteNav: 'off-canvas-site-nav',
	offCanvasCfsBadge: 'tab__link__badge',
}

const modifierNames = {
	added: 'added',
	deleted: 'deleted',
	menu: 'menu'
}

let animationTimeout;
let $cfsShortlistBadge;

const updateCfsShortlistBadge = (action) => {
	const count = cfsShortlist.count();
	$cfsShortlistBadge.html(count);

	if (!action) {
		return;
	}

	showCfsShortlistNotification(action);
}

const showCfsShortlistNotification = (action) => {
	const $mobileIcon = $.findByBem(classNames.siteHeaderMobile, classNames.icon, modifierNames.menu).hide();

	const addedClass = $.getBemClass(classNames.cfsShortlistBadge, null, modifierNames.added);
	const deletedClass = $.getBemClass(classNames.cfsShortlistBadge, null, modifierNames.deleted);

	$cfsShortlistBadge
		.removeClass(`${addedClass} ${deletedClass}`)
		.addBemClass(classNames.cfsShortlistBadge, null, action);

	clearTimeout(animationTimeout);

	animationTimeout = window.setTimeout(() => {
		$cfsShortlistBadge.removeBemClass(classNames.cfsShortlistBadge, null, action);
		$mobileIcon.fadeIn();
	}, 4000);
}

const initCfsShortlistBadge = () => {
	$cfsShortlistBadge = $.findByBem(classNames.cfsShortlistBadge);
	updateCfsShortlistBadge();
	cfsShortlist.subscribe(updateCfsShortlistBadge);
}

export default {
	init: () => {
		initCfsShortlistBadge();
	}
};